import OneClickUpsell from '~/components/builder/OneClickUpsell';
import ProductImages from '~/components/builder/ProductImages';

const components = [
  OneClickUpsell,
  ProductImages,
]

export default components;
